import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../../theme';
import { Paragraph } from '../../Paragraph';

export const StyledInputFieldsSection = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        min-width: ${theme.tggSpacing(rem(31.5), 126)};
        max-width: ${theme.tggSpacing(rem(41), 164)};
        ${theme.breakpoints.up('desktop')} {
            margin: ${theme.tggSpacing('auto', 'auto')};
        }
	`}
`;

export const StyledInstructionText = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([rem(1), 0, rem(2), 0], [4, 0, 8])};

        ${theme.breakpoints.up('desktop')} {
            margin: ${theme.tggSpacing([rem(2), 0, rem(1.1), 0], [8, 0, 4, 0])};
        }
	`}
`;

export const StyledNarrowInputFieldsWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        label + div {
            max-width: ${theme.tggSpacing(rem(15.8), 63)};
        }
	`}
`;
